type Env = 'local' | 'dev' | 'production' | 'localProd'

type Config<T> = {
  [key in Env]: T
}

const GOOGLE_CLIENT_ID_PROD = '439167645385-j4h6ibor0vv23jga5iadlfg41el36k1d.apps.googleusercontent.com'
const GOOGLE_CLIENT_ID_DEV = '549045750270-paqg8g8drnabhoo8n5u7p98m4d3oguot.apps.googleusercontent.com'

const urlApp: Config<string> = {
  local: 'http://localhost:3000',
  dev: 'https://app.nachonacho.co',
  production: 'https://app.nachonacho.com',
  localProd: 'http://localhost:3000',
}

const urlHome: Config<string> = {
  local: 'http://localhost:2200',
  dev: 'https://nachonacho.co',
  production: 'https://nachonacho.com',
  localProd: 'http://localhost:3000',
}

const apiUrl: Config<string> = {
  local: 'http://localhost:4002',
  dev: 'https://auth-api.nachonacho.co',
  production: 'https://auth-api.nachonacho.com',
  localProd: 'http://localhost:4002',
}

const googleClientId: Config<string> = {
  local: GOOGLE_CLIENT_ID_DEV,
  dev: GOOGLE_CLIENT_ID_DEV,
  production: GOOGLE_CLIENT_ID_PROD,
  localProd: GOOGLE_CLIENT_ID_DEV,
}

const recaptchaKey: Config<string> = {
  local: '6LdPp3gjAAAAAOtgBKV6fDxCDZcwQWWcN0NUZ89N',
  dev: '6LdPp3gjAAAAAOtgBKV6fDxCDZcwQWWcN0NUZ89N',
  production: '6LdYxkobAAAAAP07Nn-3zkPD9JA6w7Yyf12Iftg6',
  localProd: '6LdYxkobAAAAAP07Nn-3zkPD9JA6w7Yyf12Iftg6',
}

const url_server_public_shared_lambda: Config<string> = {
  local: 'https://public.nachonacho.co',
  dev: 'https://public.nachonacho.co',
  production: 'https://public.nachonacho.com',
  localProd: 'https://public.nachonacho.co',
}

const linkedinClientId: Config<string> = {
  local: '86b4uppnjgf3gy',
  dev: '86b4uppnjgf3gy',
  production: '86b4uppnjgf3gy',
  localProd: '86b4uppnjgf3gy',
}

const authFrontendUrl: Config<string> = {
  local: 'http://localhost:3002',
  dev: 'https://connect.nachonacho.co',
  production: 'https://connect.nachonacho.com',
  localProd: 'http://localhost:3002',
}

const url_server_media: Config<string> = {
  local: 'https://files.nachonacho.co',
  dev: 'https://files.nachonacho.co',
  production: 'https://files.nachonacho.com',
  localProd: 'https://files.nachonacho.com',
}

const googleTagManagerId: Config<string> = {
  local: 'GTM-MD7WQ6D',
  dev: 'GTM-MD7WQ6D',
  production: 'GTM-T8Q8PLN',
  localProd: 'GTM-MD7WQ6D',
}

export const env = (process.env.REACT_APP_ENV || 'local') as Env

export const URL_APP = urlApp[env]
export const URL_HOME = urlHome[env]
export const API_URL = apiUrl[env]
export const GOOGLE_CLIENT_ID = googleClientId[env]
export const RECAPTCHA_KEY = recaptchaKey[env]
export const URL_SERVER_PUBLIC_SHARED_LAMBDA = url_server_public_shared_lambda[env]
export const LINKEDIN_CLIENT_ID = linkedinClientId[env]
export const AUTH_FRONTEND_URL = authFrontendUrl[env]
export const URL_SERVER_MEDIA = url_server_media[env]
export const GOOGLE_TAG_MANAGER_ID = googleTagManagerId[env]

export const EXTENSION_ID = 'koeoaeaogagaommgnlinhmhckiibbndd'
export const RECAPTCHA_TOKEN = 'recaptchatoken'

export const KEYS = {
  AUTH_DEVICE: 'auth-device',
  RECAPTCHA_TOKEN: 'recaptcha-token',
  RECAPTCHA_ACTION: 'recaptcha-action',
}
